import { render } from "./AutoResizeInput.vue?vue&type=template&id=54748130&scoped=true&ts=true"
import script from "./AutoResizeInput.vue?vue&type=script&lang=ts"
export * from "./AutoResizeInput.vue?vue&type=script&lang=ts"

import "./AutoResizeInput.vue?vue&type=style&index=0&id=54748130&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54748130"]])

export default __exports__